import {
  STANDARD_PAGES
} from "./constants/template.js";

export default function isStandardPage(pageId) {
  return STANDARD_PAGES.includes(pageId);
}
